<template>
  <b-alert show :variant="checkGrantAccessVariant">
    <h3 class="alert-heading d-flex justify-content-between">
      Jadwal Input Nilai
      <b-badge
        :variant="checkGrantAccessVariant"
      >
        <span>{{ status }}</span>
        Input Nilai
      </b-badge>
    </h3>
    <hr class="mt-0 mb-1">
    <p class="mb-3">
      <span v-if="checkGrantAccess">
        Input nilai dapat dilakukan mulai
        <strong>{{ scheduleStart }}</strong> hingga
        <strong>{{ scheduleEnd }} WIB</strong>
      </span>
      <span v-else>
        Mohon hubungi admin SIA fakultas terkait untuk mengaktifkan jadwal input nilai.
      </span>
    </p>
  </b-alert>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GradeEntrySchedule',
  computed: {
    ...mapState('assessment', {
      grantAccess: 'lectureCanEntryAssessment',
      isGrantGradeEntry: 'isGradeEntrySchedule',
      scheduleStart: 'gradeEntryStart',
      scheduleEnd: 'gradeEntryEnd'
    }),
    status () {
      return this.grantAccess ? 'Boleh' : 'Tidak Ada Akses'
    },
    checkGrantAccessVariant () {
      return this.checkGrantAccess ? 'primary' : 'danger'
    },
    checkGrantAccess () {
      return this.isGrantGradeEntry && this.grantAccess
    }
  }
}
</script>
